<template>
    <div class="card-container agentmanage">
        <common-top-form :show="false" :model="formModel" @openAddDialog="addInfo" :submitService="submitService"
                         buttonName="导出" @reset="reset" :needReset="true" buttonType="warning"
                         addShowPower="/statis/exportByChn" :submitData="submitData" @success="onSuccess">
            <el-form-item label="通道名称">
                <el-select v-model="formModel.chnId" filterable>
                    <el-option
                        v-for="item in chnNameList"
                        :key="item.id"
                        :label="item.chnName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="路线代码" v-if="formModel.chnId">
                <el-select v-model="formModel.chnFeeId" filterable>
                    <el-option
                        v-for="item in lineCodeList"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" width="80" label="序号"></el-table-column>
            <el-table-column prop="chnName" label="通道名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="交易/消费笔数（笔）" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalAmt" label="交易金额(元)" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.totalAmt)}}</p>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import ChannelService from 'service/ChannelService'
    import StatisticsService from 'service/StatisticsService'
    import ChannelRateService from 'service/ChannelRateService'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'

    export default {
        name: "chnplanstatistics",
        data() {
            return {
                formModel: {
                    chnId: '',
                    chnFeeId: '',
                    time: TimeRange.dayRange,
                },
                tableData: [],
                submitService: StatisticsService.getStatisByChnPlan,
                page: {},
                status: '',
                showMsg: '',
                isPage: false,
                allDic: [{
                    dictKey: '',
                    dictValue: '全部'
                }],
                payTypes: [],
                chnNameList: [],
                topShortNames: [],
                lineCodeList: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mixins: [loadMixin, dialogMixin],
        components: {
            CommonTopForm,
            CommonTable,
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getchnNameList();

            this.getList();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                const params = {

                    chnFeeId: this.formModel.chnFeeId,
                    chnId: this.formModel.chnId,
                    userId: this.userId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startTime = this.formModel.time[0];
                    params.endTime = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        watch:{
            'formModel.chnId'(val, oldVal){
                if (!val){
                    this.formModel.chnFeeId = '';
                }
                this.getLineCode(val);
            },
        },
        methods: {
            getLineCode(val){
                this.doLoad(ChannelRateService.getByChn, {
                    chnId: val
                }, res => {
                    this.doCheck(res, res => {
                        this.lineCodeList = [{
                            id: '',
                            shortName: '全部'
                        }, ...res.contents];
                    });
                }, '信息获取失败')
            },
            getchnNameList() {
                this.doLoad(ChannelService.names, '', res => {
                    this.doCheck(res, res => {
                        this.chnNameList = [{
                            id: '',
                            chnName: '全部'
                        }, ...res.contents];
                    });
                }, '信息获取失败')
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(StatisticsService.getStatisByChnPlan, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.total = result.total;
                        this.page.pageSize = result.size;
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                })
            },
            reset() {
                this.formModel = {
                    chnName: '',
                    shortName: '',
                    chnFeeId: '',
                    time: TimeRange.dayRange,
                };
                this.getList();
            },
            addInfo() {
                StatisticsService.exportExcel(this.submitData, 'exportByChn')
            },
        }
    }
</script>

<style scoped>
    .detail-box p {
        font-size: 14px;
        color: #000;
        line-height: 2;
    }

    .detail-box p span {
        font-weight: 700;
        display: inline-block;
        width: 6em;
        letter-spacing: 0.13em;
        margin-right: -0.13em;
    }

    .detail-box p span.three {
        letter-spacing: 0.5em;
        margin-right: -0.5em;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/StatisticsManage/ChnPlanStatistics.vue